export const OutboxMessagesColumnNames = {
  resellerName: 'resellerName',
  scheduledMessageId: 'scheduledMessageId',
  price: 'price',
  receiverCount: 'receiverCount',
  smsText: 'smsText',
  smsParts: 'smsParts',
  senderNumber: 'senderNumber',
  sentDateTime: 'sentDateTime',
  description: 'description',
  title: 'title',
  campaignId: 'campaignId',
  isResend: 'isResend',
  isShouldNotResend: 'isShouldNotResend',
  created: 'created',
  userName: 'userName',
  organizationId: 'organizationId',
  organizationName: 'organizationName',
  privateNumberId: 'privateNumberId',
  voiceMessageId: 'voiceMessageId',
  voiceMessageGroupId: 'voiceMessageGroupId',
  fileLink: 'fileLink',
  isFirstPartOfGradualOrPeriodic: 'isFirstPartOfGradualOrPeriodic',
  isPostPaid: 'isPostPaid',
  // operatorStatuses: 'operatorStatuses',
  // processTextResults: 'processTextResults',
  status: 'status',
  sendType: 'sendType',
  sendSubType: 'sendSubType',
  creationLocation: 'creationLocation',
  cpType: 'cpType',
  createdBy: 'createdBy',
};
